module.exports = __webpack_public_path__ + "static/media/food.c6776254.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hero/assortiment/food.jpg
// module id = 894
// module chunks = 0